import { Small } from "@/shared/ui/Button/Button";
import { clsx } from "clsx";
import { Title } from "@/shared/ui/Title";
import { useDevice } from "@/shared/lib/hooks/useDevice";
import { useUser } from "@/entities/Auth";
import { UserRole } from "@/shared/const/userRole";
import { getRouteHome, getRouteLogin, getRouteManageReadings } from "@/shared/const/routes";

import cls from "./Forbidden.module.scss";

export const Forbidden = () => {
  const { isMobile } = useDevice();
  const user = useUser();

  const clickHome = () => {
    window.location.href = user.role === UserRole.Writer ? getRouteManageReadings() : getRouteHome();
  };

  const clickLogin = () => {
    window.location.href = getRouteLogin();
  };

  return (
    <div className={clsx(cls.Forbidden, { [cls.isMobile]: isMobile })}>
      <Title>Forbidden</Title>
      <div className={cls.Text}>
        <p>We really apologise, but you have no access to this page. You can try next actions below.</p>
      </div>
      <div className={cls.Buttons}>
        <Small onClick={clickHome}>Go Home</Small>
        <span>or</span>
        <Small onClick={clickLogin}>Login</Small>
      </div>
    </div>
  );
};
